import milligramStyles from "!!raw-loader!milligram/dist/milligram.css"

export const linkedCSS = [
  "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css",
]

export const styles = `
${milligramStyles}
`
